import RecurrenceFilterSwitch from './RecurrenceFilterSwitch';

export default RecurrenceFilterSwitch;
